import { StreamMedia, usePropsFor, VideoGallery, VideoTile } from '@azure/communication-react';
import React, { useCallback, useEffect, useState } from 'react'
import Avtar from "../Sub_components/Avtar";
import { useLiveStreamAppContext } from '../ContextStore/Store';
import { Features, LocalAudioStream, VideoStreamRenderer } from "@azure/communication-calling";
import IframeModal from '../PopupModal/IframeModal';
import BeRightBack from '../Components/BeRightBack';
import WaitingForHostToJoin from '../Components/WaitingForHostToJoin';
import MyLocalCameraPreview from '../Sub_components/MyLocalCameraPreview';
import { DeepNoiseSuppressionEffect } from '@azure/communication-calling-effects';
import DropDownAction from '../GeneralFunctions/DropDownAction';

export default function VideoGalleryScreen({ layout, setLayout, userName, call, hostCommunicationUserId, setHostBeRightBack, setIsHostNotJoined, hostBeRightBack, isHostNotJoined, chatThreadClientRef, sessionStartTimeUTC, setNavbarOptionMenu, setIsActive, setVertualFocusedContent, countRef, setIsContextualMenuOpen, expendVideoTile, setExpendVideoTile, deviceManager }) {
  const [isScreenShareReciveing, setIsScreenShareReciveing] = useState(false);
  const { communicationUserId, isFitToFrame, pinnedParticipants, setPinnedParticipants, toggleStates, role, __userId, appInsightTrack,
    setIsMic, attendees, ArrRemoteParticipants, setArrRemoteParticipants, attendeesLookup, webUrlSubDomain, setShowUrl, setLoading, setShowIframe, __merchantId, isInstructorMode, setIsMuted, isInstructorModeRef, setIsReciveingOrShareingScreenShare, eventType, setToggleStates, isMic, microphone, grp
  } = useLiveStreamAppContext();

  const { handleAction } = DropDownAction();
  let videoGalleryProps = usePropsFor(VideoGallery);
  let videoGalleryProps2 = usePropsFor(VideoGallery);

  const [mediaStream, setMediaStream] = useState(null);
  const [systemStream, setSystemStream] = useState(null);
  if (role === "Attendee" && isInstructorMode) {
    videoGalleryProps = { ...videoGalleryProps, remoteParticipants: videoGalleryProps.remoteParticipants.filter((e) => e.userId === hostCommunicationUserId) };
  }

  const displayUserProfile = async (participant) => {
    let matchingAttendee = attendeesLookup[participant]
    if (process.env.REACT_APP_PARENT_DOMAIN?.trim().toLowerCase() === "bookitall.com") {
      setShowUrl(process.env.REACT_APP_WEB_URL_SUBDOMAIN + "ShopOwner/LiveStreamReactVagaroPopup.aspx?popuptype=customer&businessidenc=" + __merchantId + "&useridenc=" + matchingAttendee.userId + "&isLivestreamForReact=1");
    }
    else {
      setShowUrl("https://" + grp + "." + process.env.REACT_APP_PARENT_DOMAIN + "/ShopOwner/LiveStreamReactVagaroPopup.aspx?popuptype=customer&businessidenc=" + __merchantId + "&useridenc=" + matchingAttendee.userId + "&isLivestreamForReact=1");
    }
    setShowIframe(true); // Show profile after alert
    setLoading(true)
  };
  const [views, setViews] = useState({});

  //Function for Rendering Avatar for All of the Attendees and Sending it to Video Gallery
  const onRenderAvatar = (userId, options, defaultOnRender) => {
    if (options.text === userName && !userId) {
      userId = communicationUserId.communicationUserId;
    }
    return (
      ((
        <div className="video-size-warpper">
          <Avtar
            people={{ communicationUserId: userId }}
            userName={options.text}
          />
        </div>
      ) ||
        (options && defaultOnRender?.(options))) ?? <></>
    );
  };

  //Function for Generating Remote Participants' Video Stream and Sending it to 
  const subscribeToRemoteVideoStream = useCallback(async (remoteVideoStream) => {
    try {
      const renderer = new VideoStreamRenderer(remoteVideoStream);
      return await renderer.createView();
    } catch (error) {
      console.warn("Error subscribing to remote video stream:", error);
      appInsightTrack(__merchantId, __userId, "Error subscribe to remote video stream", "", error);
    }
  }, []);

  if (expendVideoTile && !call.isScreenSharingOn) {
    const updateVideoGallery = async () => {
      try {
        videoGalleryProps = { ...videoGalleryProps, remoteParticipants: [...videoGalleryProps.remoteParticipants, { ...videoGalleryProps.localParticipant, userId: communicationUserId.communicationUserId, displayName: "You" }] }
      } catch (error) {
        console.error("Error in handling local video stream:", error);
      };
    }

    updateVideoGallery();
  } else {
    videoGalleryProps = videoGalleryProps2
  }

  //useEffect for Generating Local Video for Video Gallery
  useEffect(() => {
    const subscribeToLocalVideo = async () => {
      if (call.isLocalVideoStarted) {
        try {
          const localVideoStream = call.localVideoStreams.find(
            (stream) => stream.mediaStreamType === "Video"
          );

          if (localVideoStream) {
            const view = await subscribeToRemoteVideoStream(localVideoStream);
            setViews((prevViews) => ({
              ...prevViews,
              [communicationUserId.communicationUserId]: view,
            }));
          }
        } catch (error) {
          console.error("Error subscribing to local video stream:", error);
        }
      }
    };
    subscribeToLocalVideo();
  }, [call?.isLocalVideoStarted]);

  //Monitoring Remote Participants' Video for any changes in Real time
  const monitorParticipantVideoStream = useCallback((participant) => {
    participant.videoStreams.forEach((videoStream) => {
      const handleAvailabilityChange = async () => {
        if (videoStream.isAvailable && videoStream.mediaStreamType === "Video") {
          const view = await subscribeToRemoteVideoStream(videoStream);
          setViews((prevViews) => ({
            ...prevViews,
            [participant.identifier.communicationUserId]: view,
          }));
        }
        if (videoStream.isAvailable && videoStream.mediaStreamType === "ScreenSharing") {
          setLayout("focusedContent")
          setIsScreenShareReciveing(true)
          countRef.current = 0;
          if (layout !== "focusedContent") { setIsReciveingOrShareingScreenShare(true) }
        } else if (!videoStream.isAvailable && videoStream.mediaStreamType === "ScreenSharing") {
          setLayout("default")
          setIsScreenShareReciveing(false)
          setIsReciveingOrShareingScreenShare(false)
        }

      };

      videoStream.on("isAvailableChanged", handleAvailabilityChange);

      // Initialize view if video stream is already available
      if (videoStream.isAvailable) {
        handleAvailabilityChange();
      }

      // Cleanup listener on unmount
      return () => {
        videoStream.off("isAvailableChanged", handleAvailabilityChange);
      };
    });
  }, [subscribeToRemoteVideoStream]);


  //Send Host's Latest Settings to the joined attendee 
  const sendHostSettings = useCallback((targetUserId) => {
    chatThreadClientRef.current.sendMessage({
      content: "",
      metadata: {
        senderUserId: communicationUserId.communicationUserId,
        targetUserId,
        customType: "HOST_SETTING",
        strSessionStartTime: sessionStartTimeUTC,
        isInstructorOnlyMode: eventType === 1 ? "false" : toggleStates["InstructorMode"] ? "true" : "false",
        isDisableMichrophoneforAllAttendees: toggleStates["EnableMic"] ? "false" : "true",
        isDisableVideoforAllAttendes: toggleStates["EnableVideo"] ? "false" : "true",
        isDisableChatforAllAttendes: toggleStates["EnableChat"] ? "false" : "true",
        isStartRecording: toggleStates["StartRecording"] ? "true" : "false",
        isDisableScreenShareforAllAttendees: toggleStates["EnableScreenShare"] ? "false" : "true",
      },
    });
  }, [communicationUserId, sessionStartTimeUTC, toggleStates]);

  useEffect(() => {
    const handleNoiseSuppression = async () => {
      // Get LocalAudioStream from the localAudioStream collection on the call object
      // 'call' here represents the call object.
      const microphones = await deviceManager.getMicrophones();
      const selectedMicrophone = microphones.find(e => e._id === "microphone:" + microphone) || microphones[0]; // Ensure `microphoneId` is defined

      if (!selectedMicrophone) {
        console.error("Microphone not found");
        return; // Handle the case where the microphone is not found
      }
      // Create a LocalAudioStream from the selected microphone
      // Use the stream in the call
      const localAudioStreamInCall = call.localAudioStreams[0]
      // Get the audio effects feature API from LocalAudioStream
      const audioEffectsFeatureApi = localAudioStreamInCall.feature(Features.AudioEffects);
      if (toggleStates.removeBackgroundNoise) {
        const deepNoiseSuppression = new DeepNoiseSuppressionEffect();
        const isDeepNoiseSuppressionSupported = await audioEffectsFeatureApi.isSupported(deepNoiseSuppression);
        if (isDeepNoiseSuppressionSupported) {
          // console.log('Noise supression is supported in the current browser environment');
        } else {
          console.warn('Noise supression is not supported in the current browser environment');
        }

        // To start Communication Services Deep Noise Suppression
        await audioEffectsFeatureApi.startEffects({
          noiseSuppression: deepNoiseSuppression
        });
      } else if (audioEffectsFeatureApi.activeEffects.noiseSuppression.length > 0) {
        // To stop Communication Services Deep Noise Suppression
        await audioEffectsFeatureApi.stopEffects({
          noiseSuppression: true
        });
        if (isMic) {
          call.unmute()
        }
      }
    }
    if (deviceManager.getMicrophones) {
      handleNoiseSuppression();
    }
    let temMediaStream = mediaStream;
    let tempSystemStream = systemStream;
    let combinedStream = null;
    const stopMediaStream = async () => {
      if (temMediaStream) {
        temMediaStream.getTracks().forEach((track) => track.stop());
        setMediaStream(null);

      }
      if (tempSystemStream) {
        tempSystemStream.getTracks().forEach((track) => track.stop());
        if (call) {
          call.localAudioStreams[0].mediaStreamType === "RawMedia" && await call.stopAudio();
          if (!isMic) {
            call.mute();
          } else {
            await call.mute().then(e => call.unmute())
          }
        }
        setSystemStream(null);
      }
    };

    async function combineAudioStreams(stream1, stream2) {
      const audioContext = new AudioContext({ sampleRate: 44100 }); // Lower sample rate (e.g., 16000 Hz)
      //Recommened by Microsoft 
      //https://learn.microsoft.com/en-us/answers/questions/5727339/low-audio-quality-when-sharing-combined-system-aud
      // Create audio sources from the streams
      const source1 = audioContext.createMediaStreamSource(stream1);
      const source2 = audioContext.createMediaStreamSource(stream2);

      // Create a destination node to combine the streams
      const destination = audioContext.createMediaStreamDestination();

      // Create a DynamicsCompressorNode to compress the audio
      const compressor = audioContext.createDynamicsCompressor();
      compressor.threshold.setValueAtTime(-50, audioContext.currentTime); // Set compression threshold
      compressor.knee.setValueAtTime(40, audioContext.currentTime); // Set compression knee
      compressor.ratio.setValueAtTime(12, audioContext.currentTime); // Set compression ratio
      compressor.attack.setValueAtTime(0, audioContext.currentTime); // Set attack time
      compressor.release.setValueAtTime(0.25, audioContext.currentTime); // Set release time

      // Connect sources to the compressor, then to the destination
      source1.connect(compressor);
      source2.connect(compressor);
      compressor.connect(destination);

      // Return the combined stream
      return destination.stream;
    }

    async function singleAudioStreams(stream1) {
      const audioContext = new AudioContext();

      // Create audio sources from the streams
      const source1 = audioContext.createMediaStreamSource(stream1);

      // Create a destination node to combine the streams
      const destination = audioContext.createMediaStreamDestination();

      // Connect both sources to the destination
      source1.connect(destination);
      // Return the combined stream
      return destination.stream;
    }
    if (toggleStates.shareDeviceAudio) {
      async function startSystemAudioShare() {
        try {
          // Get the system audio and video stream
          if (!tempSystemStream) {
            tempSystemStream = await navigator.mediaDevices.getDisplayMedia({
              audio: true,
              video: true,
            });
            const hasAudio = tempSystemStream.getAudioTracks().length > 0;
            if (!hasAudio) {
              // console.log("Selected window does not have audio.");
              tempSystemStream.getVideoTracks().forEach((track) => track.stop());
              setToggleStates((prev) => ({ ...prev, shareDeviceAudio: false }));
              return false;
            }

            setSystemStream(tempSystemStream);
          }
          // Detect when the user stops sharing
          detectStopSharing(tempSystemStream, () => {
            stopMediaStream();
            // Optionally, update your state or UI here
            if (isMic) {
              (async () => {
                await call.mute().then(async e => await call.unmute())
              })();
            }
          });

          if (isMic) {
            combinedStream = tempSystemStream;
            let microphones = await deviceManager.getMicrophones();
            const selectedMicrophone = microphones.find(e => e._id === "microphone:" + microphone) || microphones[0];
            let micStream = await new LocalAudioStream(selectedMicrophone);
            // Combine the system audio and microphone audio
            combinedStream = await combineAudioStreams(tempSystemStream, await micStream.getMediaStream());
            const audio = new Audio();
            audio.srcObject = combinedStream;
            return combinedStream;
          } else {
            combinedStream = await singleAudioStreams(tempSystemStream);
            const audio = new Audio();
            audio.srcObject = combinedStream;
            return combinedStream;
          }

        } catch (err) {
          console.error("Error accessing media devices:", err);
          setToggleStates((prev) => ({ ...prev, shareDeviceAudio: false }));
        }
      }

      // Helper function to combine two audio streams
      const callStateChangedHandler = async () => {
        try {

          temMediaStream = await startSystemAudioShare();
          setMediaStream(temMediaStream);
          const localAudioStream = new LocalAudioStream(temMediaStream);
          if (call.state === "Connected") {
            await call.startAudio(localAudioStream);
          }
          if (call.isMuted) {
            call.unmute();
          }
        } catch (error) {
          console.error("Error starting audio sharing:", error);
        }
      };

      callStateChangedHandler();
    } else {
      (async () => {
        const audio = new Audio();
        audio.srcObject = combinedStream;
        return combinedStream;
      })();
      stopMediaStream();
    }
  }, [toggleStates.removeBackgroundNoise, deviceManager, call, isMic, toggleStates.shareDeviceAudio]);

  useEffect(() => {
    const handleRemoteParticipantsUpdated = (e) => {
      e.added.forEach((remoteParticipant) => {
        monitorParticipantVideoStream(remoteParticipant);
        if (role === "Attendee" && remoteParticipant.identifier.communicationUserId === hostCommunicationUserId) {
          setHostBeRightBack(false);
          setIsHostNotJoined(false);
          // if (!isMuted) call.unmute();
        } else if (role === "Presenter") {
          /*
          If Host has refreshed or just joined then no need to send individual
          Instead it should be like
          sendHostSettings("")
          */
          sendHostSettings(remoteParticipant.identifier.communicationUserId);
        }
        setArrRemoteParticipants((prev) => [...prev, remoteParticipant])
      });

      e.removed.forEach((remoteParticipant) => {
        if (role === "Attendee" && remoteParticipant.identifier.communicationUserId === hostCommunicationUserId) {
          setHostBeRightBack(true);
          setIsMic(false);
          setNavbarOptionMenu("");
          setIsActive("");
          setIsMuted(call.isMuted);
          if (!call.isMuted) call.mute();
        }
        // removeParticipantView(remoteParticipant);
        const update = ArrRemoteParticipants.filter(item => item.identifier.communicationUserId !== remoteParticipant.identifier.communicationUserId);
        setArrRemoteParticipants(update)
      });
    };

    const handleScreenSharing = (e) => {
      if (e) {
        // setLayout("focusedContent")
        setIsReciveingOrShareingScreenShare(true)
      } else {
        // setLayout("default")
        setIsReciveingOrShareingScreenShare(false)
      }
    }

    call.on("remoteParticipantsUpdated", handleRemoteParticipantsUpdated);
    call.on("isScreenSharingOnChanged", handleScreenSharing);

    return () => {
      call.off("remoteParticipantsUpdated", handleRemoteParticipantsUpdated);
      call.off("isScreenSharingOnChanged", handleScreenSharing);
    };
  }, [call, sendHostSettings, ArrRemoteParticipants]);

  const detectStopSharing = (stream, callback) => {
    if (!stream || !stream.getTracks) {
      console.error("Invalid stream provided.");
      return;
    }

    // Get all tracks from the stream
    const tracks = stream.getTracks();

    // Add an 'ended' event listener to each track
    tracks.forEach((track) => {
      track.onended = () => {
        // console.log("User stopped sharing.");
        setToggleStates((prev) => ({ ...prev, shareDeviceAudio: false }));
        if (callback && typeof callback === "function") {
          callback();
        }
        setSystemStream(null);
        setMediaStream(null);
      };
    });
  };

  const onRenderRemoteParticipant = useCallback(
    (participant) => {
      const getAttendeeProperty = (communicationUserId, property) => {
        const attendee = attendees?.find(
          (att) => att?.communicationUserId === communicationUserId
        );
        return attendee ? attendee[property] : false;
      };
      const getContextualMenuItems = () => {
        const createMenuItem = (key, text, iconName, action, isDisabled, customStyles = {}) => ({
          key,
          text,
          iconProps: {
            iconName,
            styles: { root: { lineHeight: '1rem', textAlign: 'center', ...customStyles } },
          },
          onClick: action,
          disabled: isDisabled,
        });

        const items = [];
        if (role === "Presenter") {
          items.push(
            createMenuItem(
              "mute",
              "Mute",
              "ErrorBarCallMicrophoneMutedBySystem",
              () =>
                handleAction(
                  getAttendeeProperty(participant.userId, "isMute") ? "Unmute" : "Mute",
                  participant.userId
                ),
              participant.isMuted
            )
          );

          items.push(
            createMenuItem(
              "video",
              "Disable Video",
              "IncomingCallNotificationAcceptWithVideoIcon",
              () =>
                handleAction(
                  "DisableVideo",
                  participant.userId
                ),
              !participant.videoStream.isAvailable,
              { color: getAttendeeProperty(participant.userId, "isVideoDisabled") ? "gray" : "white" }
            )
          );

          items.push(
            createMenuItem(
              "chat",
              getAttendeeProperty(participant.userId, "isChatDisabled") ? "Enable Chat" : "Disable Chat",
              getAttendeeProperty(participant.userId, "isChatDisabled")
                ? "ControlBarChatButtonActive"
                : "ControlBarChatButtonInactive",
              () =>
                handleAction(
                  getAttendeeProperty(participant.userId, "isChatDisabled")
                    ? "EnableChat"
                    : "DisableChat",
                  participant.userId
                ),
              !toggleStates.EnableChat
            )
          );


          items.push(
            createMenuItem(
              "screenShare",
              getAttendeeProperty(participant.userId, "isScreenShareDisabled")
                ? "Enable ScreenShare"
                : "Disable ScreenShare",
              "ControlButtonScreenShareStart",
              () =>
                handleAction(
                  getAttendeeProperty(participant.userId, "isScreenShareDisabled")
                    ? "EnableScreenShare"
                    : "DisableScreenShare",
                  participant.userId
                ),
              isInstructorMode || !toggleStates.EnableScreenShare
            )
          );

          items.push(
            createMenuItem(
              "profile",
              participant.displayName,
              "PeoplePaneAddPerson",
              () => displayUserProfile(participant.userId)
            )
          );
        }

        items.push(
          pinnedParticipants.includes(participant.userId)
            ? createMenuItem(
              "unPin",
              "Unpin",
              "UnpinParticipant",
              () => handleAction("Unpin", participant.userId)
            )
            : createMenuItem(
              "pin",
              "Pin",
              "VideoTilePinned",
              () => handleAction("Pin", participant.userId)
            )
        );

        return items;
      };

      const onRenderPlaceholder = (userId, options) => (
        <div className="video-size-warpper">
          <Avtar
            people={{ communicationUserId: userId }}
            userName={options.text === "You" ? userName : options.text}
          />
        </div>
      );

      return (
        <div key={participant.userId} className='box-position'>
          <VideoTile
            isMirrored={participant.userId !== communicationUserId.communicationUserId}
            displayName={participant.displayName}
            userId={participant.userId}
            renderElement={
              participant.videoStream.isAvailable && views[participant.userId] ? (
                <StreamMedia videoStreamElement={views[participant.userId].target} />
              ) : (
                ""
              )
            }
            isVideoReady={participant.videoStream.isAvailable}
            isMuted={participant.isMuted}
            contextualMenu={((role === "Presenter") || (!isInstructorModeRef.current && role === "Attendee")) && !(layout === "floatingLocalVideo" && participant.displayName === "You") && {
              items: getContextualMenuItems(), onMenuOpened: async () => {
                setIsContextualMenuOpen(true)
              },
              onMenuDismissed: () => {
                setIsContextualMenuOpen(false)
              }
            }}
            onRenderPlaceholder={onRenderPlaceholder}
            isPinned={pinnedParticipants.includes(participant.userId)}
          // isMirrored
          />
          {layout !== "default" && participant.userId === communicationUserId.communicationUserId && !call.isScreenSharingOn && <div className='icon-wrap'>
            <div className='expend-icon ex-close' onClick={() => { setExpendVideoTile(false) }}>
              <i className="fa-solid fa-down-left-and-up-right-to-center"></i>
            </div>
          </div>}
          <IframeModal />
        </div>
      );
    },
    [views,
      pinnedParticipants, role, handleAction,
      displayUserProfile,
      attendees,
      toggleStates,
      setPinnedParticipants,
      expendVideoTile
    ]
  );

  const onRenderLocalParticipant = useCallback((participant) => {
    const onRenderPlaceholder = (userId, options) => (
      <div className={`video-size-warpper  ${layout === "speaker" ? "small-avatar" : ""} `}>
        <Avtar
          people={{ communicationUserId: userId }}
          userName={participant.displayName}
        />
      </div>
    );
    return (
      <div className={`${layout !== "default" ? "video-size-warpper" : "video-size-warpper-video-tile"}`}>
        <VideoTile
          displayName={'You'}
          isMirrored={!toggleStates.mirrorMyVideo}
          userId={
            communicationUserId.communicationUserId
          }
          renderElement={
            participant.videoStream.isAvailable && views[communicationUserId?.communicationUserId] ? (
              <StreamMedia videoStreamElement={views[communicationUserId?.communicationUserId]?.target} />
            ) : ("")
          }
          onRenderPlaceholder={onRenderPlaceholder}
          isVideoReady={participant.videoStream.isAvailable}
          isMuted={participant.isMuted}
        />
        {layout === "floatingLocalVideo" && !call.isScreenSharingOn && <div className='icon-wrap'>
          <div className='expend-icon' onClick={() => { setExpendVideoTile(true) }}>
            <i className="fa-solid fa-up-right-and-down-left-from-center"></i>
          </div>
        </div>}
      </div>
    );
  }, [views, communicationUserId.communicationUserId, layout, expendVideoTile, toggleStates.mirrorMyVideo]);


  return (
    <>
      {isHostNotJoined && <WaitingForHostToJoin call={call} />}
      {hostBeRightBack && !isHostNotJoined && <BeRightBack />}
      {(hostBeRightBack || isHostNotJoined) && deviceManager && <MyLocalCameraPreview
        deviceManager={deviceManager}
        call={call}
      />}

      {!hostBeRightBack && !isHostNotJoined && <div
        className={`VideoGallery-wrapper backgroundgray ${isFitToFrame || (isScreenShareReciveing || call?.isScreenSharingOn) ? "video-aspect-ratios" : ""
          } `}
        id="videoGallery"
      >

        {ArrRemoteParticipants.length === 0 && !call.isLocalVideoStarted ? (
          <div className="video-size-warpper">
            <Avtar
              people={{ communicationUserId: hostCommunicationUserId }}
              userName={userName}
            />
          </div>
        ) : (
          <VideoGallery
            {...videoGalleryProps}
            layout={layout}
            onRenderAvatar={onRenderAvatar}
            onRenderRemoteVideoTile={onRenderRemoteParticipant}
            onRenderLocalVideoTile={!call.isScreenSharingOn ? onRenderLocalParticipant : undefined}
            localVideoTileSize={expendVideoTile && !call.isScreenSharingOn ? "hidden" : "followDeviceOrientation"}
            onDisposeRemoteVideoStreamView={(userId) => {
              setViews((prevViews) => {
                const newViews = { ...prevViews };
                if (newViews[userId]) {
                  newViews[userId].dispose(); // Dispose the view
                  delete newViews[userId];
                }
                return newViews;
              });
            }}
            onDisposeLocalStreamView={(userId) => {
              setViews((prevViews) => {
                const newViews = { ...prevViews };
                if (newViews[userId]) {
                  newViews[userId].dispose(); // Dispose the view
                  delete newViews[userId];
                }
                return newViews;
              });
            }}
            pinnedParticipants={pinnedParticipants}
            onPinParticipant={(communicationUserId) =>
              setPinnedParticipants((prev) => [...prev, communicationUserId])
            }
            onUnpinParticipant={(communicationUserId) =>
              setPinnedParticipants((prev) =>
                prev.filter((userId) => userId !== communicationUserId)
              )
            }
            spotlightedParticipants={layout === "floatingLocalVideo" && expendVideoTile ? [communicationUserId.communicationUserId] : []}
          />
        )}
      </div>}
    </>
  )
}
